// Fichier de traductions complet pour le formulaire d'estimation - 7 langues
export const translations = {
  fr: {
    // En-tête
    headerTitle: "Formulaire de demande de renseignements strictement confidentiels afin d'évaluer votre capacité d'emprunt et vous proposer des biens neufs correspondant à vos attentes",
    stepProgress: "Étape",
    of: "sur",
    
    // Navigation
    previous: "Précédent",
    next: "Suivant",
    submit: "Envoyer le formulaire",
    fillRequired: "Veuillez remplir les champs obligatoires surlignés en rouge",
    fieldsRemaining: "champ(s) obligatoire(s) à remplir",
    allFieldsCompleted: "Tous les champs obligatoires sont remplis ✓",
    reviewTitle: "Vérifiez vos informations",
    reviewDesc: "Veuillez vérifier vos réponses avant l'envoi définitif.",
    edit: "Modifier",
    confirmSend: "Confirmer et envoyer",
    draftRestored: "Vos réponses précédentes ont été restaurées",
    sending: "Envoi en cours…",
    draftBannerText: "Vous avez un questionnaire en cours.",
    resume: "Reprendre",
    startOver: "Recommencer",
    quickMinutes: "⏱️ Moins de 2 minutes",
    yourAdvisor: "Votre conseiller :",
    recommendedBy: "Recommandé par",
    almostDone: "🎉 Dernière étape, presque terminé !",
    pdfButton: "Télécharger mon récapitulatif PDF",
    pdfGenerating: "Génération du PDF…",
    pdfTitle: "Récapitulatif de votre demande d'estimation",
    pdfIntro: "Voici le récapitulatif des informations que vous nous avez transmises. Conservez ce document, notre équipe vous recontactera très prochainement.",
    pdfField: "Information",
    pdfValue: "Détail",
    pdfFooter: "Document généré automatiquement — LOVELIA — IMMOBILIER NEUF",
    pdfError: "Impossible de générer le PDF, veuillez réessayer.",
    newRequest: "Faire une nouvelle demande",
    rgpdNotice: "🔒 Vos informations sont strictement confidentielles et utilisées uniquement pour évaluer votre projet (conformément au RGPD - Loi n°2018-493).",
    invalidEmail: "Adresse email invalide",
    invalidPhone: "Numéro de téléphone invalide",
    submitting: "Envoi en cours...",
    
    // Étape 1 : Informations Personnelles
    personalInfo: "Informations Personnelles",
    personalInfoDesc: "Vos coordonnées et informations de contact",
    recommended: "Une personne vous a recommandé mes services ?",
    selectAnswer: "Sélectionnez une réponse",
    yes: "Oui",
    no: "Non",
    recommendedByFull: "Merci de m'indiquer son nom et prénom",
    civility: "Civilité",
    selectCivility: "Sélectionnez votre civilité",
    mr: "Monsieur",
    mrs: "Madame",
    couple: "Couple",
    lastName: "Nom",
    lastNamePlaceholder: "Votre nom",
    firstName: "Prénom",
    firstNamePlaceholder: "Votre prénom",
    address: "Adresse",
    addressPlaceholder: "Numéro et nom de rue",
    postalCode: "Code postal",
    postalCodePlaceholder: "Ex: 69001",
    city: "Ville",
    cityPlaceholder: "Votre ville",
    phone: "Téléphone",
    phonePlaceholder: "06 12 34 56 78",
    email: "Email",
    emailPlaceholder: "votre.email@exemple.com",
    birthDateMr: "Date de naissance - Monsieur",
    birthDateMrs: "Date de naissance - Madame",
    birthDatePlaceholder: "jj/mm/aaaa",
    
    // Étape 2 : Situation Familiale
    familyStatus: "Situation Familiale",
    familyStatusDesc: "Informations sur votre foyer",
    familySituationAndIncome: "Situation Familiale & Revenus",
    familySituationAndIncomeDesc: "Informations sur votre foyer et vos revenus",
    netMonthlyIncome: "Revenus mensuels nets",
    maritalStatus: "Situation familiale",
    selectMaritalStatus: "Sélectionnez votre situation",
    single: "Célibataire",
    married: "Marié(e)",
    pacs: "Pacsé(e)",
    divorced: "Divorcé(e)",
    children: "Nombre d'enfants",
    childrenLabel: "Nombre d'enfants",
    selectChildren: "Sélectionnez le nombre",
    currentRent: "Loyer actuel (€/mois)",
    currentRentLabel: "€ Loyer actuel mensuel (€)",
    currentRentPlaceholder: "Ex: 800",
    
    // Étape 3 : Revenus Monsieur
    maleIncome: "Revenus Monsieur",
    maleIncomeLabel: "Revenus de Monsieur",
    maleIncomeDesc: "Informations professionnelles et revenus",
    grossSalary: "Salaire brut (€/mois)",
    grossSalaryPlaceholder: "Ex: 3000",
    netSalary: "Salaire net (€/mois)",
    netSalaryPlaceholder: "Ex: 2400",
    bonuses: "Primes annuelles (€)",
    bonusesPlaceholder: "Ex: 1200",
    status: "Statut",
    selectStatus: "Sélectionnez votre statut",
    cdi: "CDI",
    cdd: "CDD",
    interim: "Intérim",
    selfEmployed: "Indépendant",
    retired: "Retraité",
    other: "Autre",
    profession: "Profession",
    professionPlaceholder: "Votre profession",
    workplace: "Lieu de travail",
    workplacePlaceholder: "Ex: Lyon",
    
    // Étape 4 : Revenus Madame
    femaleIncome: "Revenus Madame",
    femaleIncomeLabel: "Revenus de Madame",
    femaleIncomeDesc: "Informations professionnelles et revenus",
    
    // Étape 5 : Autres Revenus
    otherIncome: "Autres Revenus",
    otherIncomeDesc: "Revenus complémentaires",
    cafIncome: "Revenus CAF (€/mois)",
    cafIncomeLabel: "Revenus CAF (€)",
    cafIncomePlaceholder: "Ex: 200",
    
    // Étape 6 : Situation Bancaire
    bankingSituation: "Situation Bancaire",
    bankingSituationDesc: "Vos crédits et engagements bancaires",
    currentBank: "Banque actuelle",
    currentBankPlaceholder: "Ex: BNP Paribas",
    existingCredit: "Crédit en cours",
    existingCreditQuestion: "Haben Sie laufende Kredite, die in mehr als 6 Monaten enden?",
    creditInfo: "Informationen zu Ihrem laufenden Kredit",
    existingCreditQuestion: "Ha crediti in corso che terminano tra più di 6 mesi?",
    creditInfo: "Informazioni sul suo credito in corso",
    existingCreditQuestion: "¿Tiene créditos en curso que terminan en más de 6 meses?",
    creditInfo: "Información sobre su crédito en curso",
    existingCreditQuestion: "Avez-vous des crédits en cours qui se terminent dans plus de 6 mois ?",
    creditInfo: "Informations sur votre crédit en cours",
    creditOrganization: "Organisme de crédit",
    creditOrganizationQuestion: "Bei welchem Institut?",
    creditOrganizationQuestion: "In quale organismo?",
    creditOrganizationQuestion: "¿En qué organismo?",
    creditOrganizationQuestion: "Dans quel organisme ?",
    creditOrganizationPlaceholder: "Ex: Cetelem",
    monthlyPayment: "Mensualité (€/mois)",
    monthlyPaymentQuestion: "Wie viel zahlen Sie pro Monat (€)?",
    monthlyPaymentQuestion: "Quanto paga al mese (€)?",
    monthlyPaymentQuestion: "¿Cuánto paga al mes (€)?",
    monthlyPaymentQuestion: "Combien remboursez-vous par mois (€) ?",
    monthlyPaymentPlaceholder: "Ex: 300",
    remainingAmount: "Montant restant (€)",
    remainingAmountQuestion: "Wie viel müssen Sie noch zurückzahlen (€)?",
    remainingAmountQuestion: "Quanto le resta da pagare (€)?",
    remainingAmountQuestion: "¿Cuánto le queda por pagar (€)?",
    remainingAmountQuestion: "Combien vous reste-t-il à rembourser (€) ?",
    remainingAmountPlaceholder: "Ex: 15000",
    financialSituation: "Situation Financière",
    financialSituationDesc: "Vos informations bancaires et financières",
    yourBanks: "Quelle est votre ou vos banque(s) actuelle(s)",
    yourBanksPlaceholder: "Ex: Crédit Agricole, BNP Paribas...",
    downPayment: "Quel est votre apport disponible pour votre projet (€)",
    downPaymentPlaceholder: "0",
    desiredMonthlyRepayment: "Mensualité de remboursement de prêt souhaitée (€)",
    desiredMonthlyRepaymentPlaceholder: "0",
    
    // Étape 7 : Projet Immobilier
    realEstateProject: "Projet Immobilier",
    realEstateProjectDesc: "Le bien que vous recherchez",
    yourRealEstateProject: "Votre Projet Immobilier",
    describePropertyYouAreLookingFor: "Décrivez le bien que vous recherchez",
    propertyTypeLabel: "Type de bien recherché",
    selectPropertyTypePlaceholder: "Choisissez le type de bien",
    bedroomsLabel: "Nombre de chambres souhaitées",
    bedroomsPlaceholder: "Nombre de chambres",
    propertyType: "Type de bien",
    selectPropertyType: "Sélectionnez le type",
    apartment: "Appartement",
    house: "Maison",
    bedrooms: "Nombre de chambres",
    selectBedrooms: "Sélectionnez le nombre",
    citiesOrDepartments: "Dans quelles villes ou départements souhaiteriez-vous habiter?",
    citiesPlaceholder: "Ex: Lyon, Villeurbanne, Rhône (69), etc.",
    contribution: "Apport personnel (€)",
    contributionPlaceholder: "Ex: 50000",
    desiredMonthly: "Mensualité souhaitée (€/mois)",
    desiredMonthlyPlaceholder: "Ex: 1200",
    propertyDescription: "Les critères importants pour vous",
    propertyDescriptionPlaceholder: "Décrivez vos attentes (proximité transports, écoles, commerces, etc.)",
  },
  
  en: {
    // Header
    headerTitle: "Strictly confidential information request form to assess your borrowing capacity and offer you new properties that match your expectations",
    stepProgress: "Step",
    of: "of",
    
    // Navigation
    previous: "Previous",
    next: "Next",
    submit: "Submit form",
    fillRequired: "Please fill in the required fields highlighted in red",
    fieldsRemaining: "required field(s) left to fill",
    allFieldsCompleted: "All required fields completed ✓",
    reviewTitle: "Review your information",
    reviewDesc: "Please review your answers before final submission.",
    edit: "Edit",
    confirmSend: "Confirm and send",
    draftRestored: "Your previous answers have been restored",
    sending: "Sending…",
    draftBannerText: "You have a questionnaire in progress.",
    resume: "Resume",
    startOver: "Start over",
    quickMinutes: "⏱️ Less than 2 minutes",
    yourAdvisor: "Your advisor:",
    recommendedBy: "Recommended by",
    almostDone: "🎉 Last step, almost done!",
    pdfButton: "Download my PDF summary",
    pdfGenerating: "Generating PDF…",
    pdfTitle: "Summary of your estimation request",
    pdfIntro: "Here is a summary of the information you provided. Keep this document; our team will contact you very soon.",
    pdfField: "Information",
    pdfValue: "Details",
    pdfFooter: "Automatically generated document — LOVELIA — IMMOBILIER NEUF",
    pdfError: "Could not generate the PDF, please try again.",
    newRequest: "Make a new request",
    rgpdNotice: "🔒 Your information is strictly confidential and used only to assess your project (GDPR compliant).",
    invalidEmail: "Invalid email address",
    invalidPhone: "Invalid phone number",
    submitting: "Submitting...",
    
    // Step 1: Personal Information
    personalInfo: "Personal Information",
    personalInfoDesc: "Your contact details and information",
    recommended: "Were you recommended by someone?",
    selectAnswer: "Select an answer",
    yes: "Yes",
    no: "No",
    recommendedByFull: "Please provide their full name",
    civility: "Title",
    selectCivility: "Select your title",
    mr: "Mr",
    mrs: "Mrs",
    couple: "Couple",
    lastName: "Last Name",
    lastNamePlaceholder: "Your last name",
    firstName: "First Name",
    firstNamePlaceholder: "Your first name",
    address: "Address",
    addressPlaceholder: "Street number and name",
    postalCode: "Postal Code",
    postalCodePlaceholder: "E.g.: 69001",
    city: "City",
    cityPlaceholder: "Your city",
    phone: "Phone",
    phonePlaceholder: "06 12 34 56 78",
    email: "Email",
    emailPlaceholder: "your.email@example.com",
    birthDateMr: "Date of birth - Mr.",
    birthDateMrs: "Date of birth - Mrs.",
    birthDatePlaceholder: "dd/mm/yyyy",
    
    // Step 2: Family Status
    familyStatus: "Family Situation",
    familyStatusDesc: "Information about your household",
    familySituationAndIncome: "Family Situation & Income",
    familySituationAndIncomeDesc: "Information about your household and income",
    netMonthlyIncome: "Net monthly income",
    maritalStatus: "Marital status",
    selectMaritalStatus: "Select your status",
    single: "Single",
    married: "Married",
    pacs: "Civil partnership",
    divorced: "Divorced",
    children: "Number of children",
    childrenLabel: "Number of children",
    selectChildren: "Select the number",
    currentRent: "Current rent (€/month)",
    currentRentLabel: "€ Current monthly rent (€)",
    currentRentPlaceholder: "E.g.: 800",
    
    // Step 3: Male Income
    maleIncome: "Male Income",
    maleIncomeLabel: "Mr.'s Income",
    maleIncomeDesc: "Professional information and income",
    grossSalary: "Gross salary (€/month)",
    grossSalaryPlaceholder: "E.g.: 3000",
    netSalary: "Net salary (€/month)",
    netSalaryPlaceholder: "E.g.: 2400",
    bonuses: "Annual bonuses (€)",
    bonusesPlaceholder: "E.g.: 1200",
    status: "Status",
    selectStatus: "Select your status",
    cdi: "Permanent contract",
    cdd: "Fixed-term contract",
    interim: "Temporary",
    selfEmployed: "Self-employed",
    retired: "Retired",
    other: "Other",
    profession: "Profession",
    professionPlaceholder: "Your profession",
    workplace: "Workplace",
    workplacePlaceholder: "E.g.: Lyon",
    
    // Step 4: Female Income
    femaleIncome: "Female Income",
    femaleIncomeLabel: "Mrs.'s Income",
    femaleIncomeDesc: "Professional information and income",
    
    // Step 5: Other Income
    otherIncome: "Other Income",
    otherIncomeDesc: "Additional income",
    cafIncome: "Family benefits (€/month)",
    cafIncomeLabel: "Family benefits (€)",
    cafIncomePlaceholder: "E.g.: 200",
    
    // Step 6: Banking Situation
    bankingSituation: "Banking Situation",
    bankingSituationDesc: "Your credits and banking commitments",
    currentBank: "Current bank",
    currentBankPlaceholder: "E.g.: BNP Paribas",
    existingCredit: "Existing credit",
    existingCreditQuestion: "Haben Sie laufende Kredite, die in mehr als 6 Monaten enden?",
    creditInfo: "Informationen zu Ihrem laufenden Kredit",
    existingCreditQuestion: "Ha crediti in corso che terminano tra più di 6 mesi?",
    creditInfo: "Informazioni sul suo credito in corso",
    existingCreditQuestion: "¿Tiene créditos en curso que terminan en más de 6 meses?",
    creditInfo: "Información sobre su crédito en curso",
    existingCreditQuestion: "Do you have any credits ongoing that will finish in more than 6 months?",
    creditInfo: "Information about your current credit",
    creditOrganization: "Credit organization",
    creditOrganizationQuestion: "Bei welchem Institut?",
    creditOrganizationQuestion: "In quale organismo?",
    creditOrganizationQuestion: "¿En qué organismo?",
    creditOrganizationQuestion: "In which organization?",
    creditOrganizationPlaceholder: "E.g.: Cetelem",
    monthlyPayment: "Monthly payment (€/month)",
    monthlyPaymentQuestion: "Wie viel zahlen Sie pro Monat (€)?",
    monthlyPaymentQuestion: "Quanto paga al mese (€)?",
    monthlyPaymentQuestion: "¿Cuánto paga al mes (€)?",
    monthlyPaymentQuestion: "How much do you repay per month (€)?",
    monthlyPaymentPlaceholder: "E.g.: 300",
    remainingAmount: "Remaining amount (€)",
    remainingAmountQuestion: "Wie viel müssen Sie noch zurückzahlen (€)?",
    remainingAmountQuestion: "Quanto le resta da pagare (€)?",
    remainingAmountQuestion: "¿Cuánto le queda por pagar (€)?",
    remainingAmountQuestion: "How much do you still have to repay (€)?",
    remainingAmountPlaceholder: "E.g.: 15000",
    financialSituation: "Financial Situation",
    financialSituationDesc: "Your banking and financial information",
    yourBanks: "What is/are your current bank(s)",
    yourBanksPlaceholder: "E.g.: Crédit Agricole, BNP Paribas...",
    downPayment: "What is your available down payment for your project (€)",
    downPaymentPlaceholder: "0",
    desiredMonthlyRepayment: "Desired loan repayment monthly payment (€)",
    desiredMonthlyRepaymentPlaceholder: "0",
    
    // Step 7: Real Estate Project
    realEstateProject: "Real Estate Project",
    realEstateProjectDesc: "The property you are looking for",
    yourRealEstateProject: "Your Real Estate Project",
    describePropertyYouAreLookingFor: "Describe the property you are looking for",
    propertyTypeLabel: "Type of property sought",
    selectPropertyTypePlaceholder: "Choose the type of property",
    bedroomsLabel: "Desired number of bedrooms",
    bedroomsPlaceholder: "Number of bedrooms",
    propertyType: "Property type",
    selectPropertyType: "Select the type",
    apartment: "Apartment",
    house: "House",
    bedrooms: "Number of bedrooms",
    selectBedrooms: "Select the number",
    citiesOrDepartments: "In which cities or departments would you like to live?",
    citiesPlaceholder: "E.g.: Lyon, Villeurbanne, Rhône (69), etc.",
    contribution: "Personal contribution (€)",
    contributionPlaceholder: "E.g.: 50000",
    desiredMonthly: "Desired monthly payment (€/month)",
    desiredMonthlyPlaceholder: "E.g.: 1200",
    propertyDescription: "Important criteria for you",
    propertyDescriptionPlaceholder: "Describe your expectations (proximity to transport, schools, shops, etc.)",
  },
  
  pt: {
    // Cabeçalho
    headerTitle: "Formulário de pedido de informações estritamente confidencial para avaliar a sua capacidade de crédito e propor-lhe imóveis novos que correspondam às suas expectativas",
    stepProgress: "Etapa",
    of: "de",
    
    // Navegação
    previous: "Anterior",
    next: "Seguinte",
    submit: "Enviar formulário",
    fillRequired: "Por favor, preencha os campos obrigatórios destacados a vermelho",
    fieldsRemaining: "campo(s) obrigatório(s) por preencher",
    allFieldsCompleted: "Todos os campos obrigatórios preenchidos ✓",
    reviewTitle: "Verifique as suas informações",
    reviewDesc: "Verifique as suas respostas antes do envio final.",
    edit: "Editar",
    confirmSend: "Confirmar e enviar",
    draftRestored: "As suas respostas anteriores foram restauradas",
    sending: "A enviar…",
    draftBannerText: "Tem um questionário em curso.",
    resume: "Retomar",
    startOver: "Recomeçar",
    quickMinutes: "⏱️ Menos de 2 minutos",
    yourAdvisor: "O seu consultor:",
    recommendedBy: "Recomendado por",
    almostDone: "🎉 Última etapa, quase concluído!",
    pdfButton: "Descarregar o meu resumo PDF",
    pdfGenerating: "A gerar o PDF…",
    pdfTitle: "Resumo do seu pedido de estimativa",
    pdfIntro: "Aqui está o resumo das informações que nos forneceu. Guarde este documento; a nossa equipa entrará em contacto muito em breve.",
    pdfField: "Informação",
    pdfValue: "Detalhe",
    pdfFooter: "Documento gerado automaticamente — LOVELIA — IMMOBILIER NEUF",
    pdfError: "Não foi possível gerar o PDF, tente novamente.",
    newRequest: "Fazer um novo pedido",
    rgpdNotice: "🔒 As suas informações são estritamente confidenciais e usadas apenas para avaliar o seu projeto (conforme o RGPD).",
    invalidEmail: "Endereço de email inválido",
    invalidPhone: "Número de telefone inválido",
    submitting: "A enviar...",
    
    // Etapa 1: Informações Pessoais
    personalInfo: "Informações Pessoais",
    personalInfoDesc: "Os seus contactos e informações",
    recommended: "Foi recomendado por alguém?",
    selectAnswer: "Selecione uma resposta",
    yes: "Sim",
    no: "Não",
    recommendedByFull: "Por favor indique o nome completo",
    civility: "Título",
    selectCivility: "Selecione o seu título",
    mr: "Sr.",
    mrs: "Sra.",
    couple: "Casal",
    lastName: "Apelido",
    lastNamePlaceholder: "O seu apelido",
    firstName: "Nome",
    firstNamePlaceholder: "O seu nome",
    address: "Endereço",
    addressPlaceholder: "Número e nome da rua",
    postalCode: "Código postal",
    postalCodePlaceholder: "Ex: 69001",
    city: "Cidade",
    cityPlaceholder: "A sua cidade",
    phone: "Telefone",
    phonePlaceholder: "06 12 34 56 78",
    email: "Email",
    emailPlaceholder: "o.seu.email@exemplo.com",
    birthDateMr: "Data de nascimento - Sr.",
    birthDateMrs: "Data de nascimento - Sra.",
    birthDatePlaceholder: "dd/mm/aaaa",
    
    // Etapa 2: Situação Familiar
    familyStatus: "Situação Familiar",
    familyStatusDesc: "Informações sobre o seu agregado",
    maritalStatus: "Estado civil",
    selectMaritalStatus: "Selecione o seu estado",
    single: "Solteiro(a)",
    married: "Casado(a)",
    pacs: "União de facto",
    divorced: "Divorciado(a)",
    children: "Número de filhos",
    childrenLabel: "Número de filhos",
    selectChildren: "Selecione o número",
    currentRent: "Renda atual (€/mês)",
    currentRentLabel: "€ Renda mensal atual (€)",
    currentRentPlaceholder: "Ex: 800",
    
    // Etapa 3: Rendimentos Homem
    maleIncome: "Rendimentos Homem",
    maleIncomeLabel: "Rendimentos do Sr.",
    maleIncomeDesc: "Informações profissionais e rendimentos",
    grossSalary: "Salário bruto (€/mês)",
    grossSalaryPlaceholder: "Ex: 3000",
    netSalary: "Salário líquido (€/mês)",
    netSalaryPlaceholder: "Ex: 2400",
    bonuses: "Prémios anuais (€)",
    bonusesPlaceholder: "Ex: 1200",
    status: "Estatuto",
    selectStatus: "Selecione o seu estatuto",
    cdi: "Contrato permanente",
    cdd: "Contrato a termo",
    interim: "Temporário",
    selfEmployed: "Trabalhador independente",
    retired: "Reformado",
    other: "Outro",
    profession: "Profissão",
    professionPlaceholder: "A sua profissão",
    workplace: "Local de trabalho",
    workplacePlaceholder: "Ex: Lyon",
    
    // Etapa 4: Rendimentos Mulher
    femaleIncome: "Rendimentos Mulher",
    femaleIncomeLabel: "Rendimentos da Sra.",
    femaleIncomeDesc: "Informações profissionais e rendimentos",
    
    // Etapa 5: Outros Rendimentos
    otherIncome: "Outros Rendimentos",
    otherIncomeDesc: "Rendimentos adicionais",
    cafIncome: "Abonos de família (€/mês)",
    cafIncomeLabel: "Abonos de família (€)",
    cafIncomePlaceholder: "Ex: 200",
    
    // Etapa 6: Situação Bancária
    bankingSituation: "Situação Bancária",
    bankingSituationDesc: "Os seus créditos e compromissos bancários",
    currentBank: "Banco atual",
    currentBankPlaceholder: "Ex: BNP Paribas",
    existingCredit: "Crédito em curso",
    existingCreditQuestion: "Tem créditos em curso que terminam em mais de 6 meses?",
    creditInfo: "Informações sobre o seu crédito em curso",
    creditOrganization: "Organismo de crédito",
    creditOrganizationQuestion: "Em que organismo?",
    creditOrganizationPlaceholder: "Ex: Cetelem",
    monthlyPayment: "Mensalidade (€/mês)",
    monthlyPaymentQuestion: "Quanto paga por mês (€)?",
    monthlyPaymentPlaceholder: "Ex: 300",
    remainingAmount: "Montante restante (€)",
    remainingAmountQuestion: "Quanto lhe falta pagar (€)?",
    remainingAmountPlaceholder: "Ex: 15000",
    financialSituation: "Situação Financeira",
    financialSituationDesc: "As suas informações bancárias e financeiras",
    yourBanks: "Qual(is) é/são o(s) seu(s) banco(s) atual(is)",
    yourBanksPlaceholder: "Ex: Crédit Agricole, BNP Paribas...",
    downPayment: "Qual é o seu aporte disponível para o seu projeto (€)",
    downPaymentPlaceholder: "0",
    desiredMonthlyRepayment: "Mensalidade de reembolso de empréstimo desejada (€)",
    desiredMonthlyRepaymentPlaceholder: "0",
    
    // Etapa 7: Projeto Imobiliário
    realEstateProject: "Projeto Imobiliário",
    realEstateProjectDesc: "O imóvel que procura",
    yourRealEstateProject: "O Seu Projeto Imobiliário",
    describePropertyYouAreLookingFor: "Descreva o imóvel que procura",
    propertyType: "Tipo de imóvel",
    propertyTypeLabel: "Tipo de imóvel procurado",
    selectPropertyType: "Selecione o tipo",
    selectPropertyTypePlaceholder: "Escolha o tipo de imóvel",
    apartment: "Apartamento",
    house: "Casa",
    bedrooms: "Número de quartos",
    bedroomsLabel: "Número de quartos desejados",
    bedroomsPlaceholder: "Número de quartos",
    selectBedrooms: "Selecione o número",
    citiesOrDepartments: "Em que cidades ou departamentos gostaria de viver?",
    citiesPlaceholder: "Ex: Lyon, Villeurbanne, Rhône (69), etc.",
    contribution: "Contribuição pessoal (€)",
    contributionPlaceholder: "Ex: 50000",
    desiredMonthly: "Mensalidade desejada (€/mês)",
    desiredMonthlyPlaceholder: "Ex: 1200",
    propertyDescription: "Critérios importantes para si",
    propertyDescriptionPlaceholder: "Descreva as suas expectativas (proximidade de transportes, escolas, comércio, etc.)",
  },
  
  es: {
    // Encabezado
    headerTitle: "Formulario de solicitud de información estrictamente confidencial para evaluar su capacidad de endeudamiento y proponerle propiedades nuevas que se ajusten a sus expectativas",
    stepProgress: "Paso",
    of: "de",
    
    // Navegación
    previous: "Anterior",
    next: "Siguiente",
    submit: "Enviar formulario",
    fillRequired: "Por favor, complete los campos obligatorios resaltados en rojo",
    fieldsRemaining: "campo(s) obligatorio(s) por completar",
    allFieldsCompleted: "Todos los campos obligatorios completados ✓",
    reviewTitle: "Verifique su información",
    reviewDesc: "Revise sus respuestas antes del envío final.",
    edit: "Editar",
    confirmSend: "Confirmar y enviar",
    draftRestored: "Sus respuestas anteriores han sido restauradas",
    sending: "Enviando…",
    draftBannerText: "Tiene un cuestionario en curso.",
    resume: "Continuar",
    startOver: "Empezar de nuevo",
    quickMinutes: "⏱️ Menos de 2 minutos",
    yourAdvisor: "Su asesor:",
    recommendedBy: "Recomendado por",
    almostDone: "🎉 Último paso, ¡casi listo!",
    pdfButton: "Descargar mi resumen PDF",
    pdfGenerating: "Generando PDF…",
    pdfTitle: "Resumen de su solicitud de estimación",
    pdfIntro: "Aquí tiene el resumen de la información que nos ha facilitado. Conserve este documento; nuestro equipo se pondrá en contacto muy pronto.",
    pdfField: "Información",
    pdfValue: "Detalle",
    pdfFooter: "Documento generado automáticamente — LOVELIA — IMMOBILIER NEUF",
    pdfError: "No se pudo generar el PDF, inténtelo de nuevo.",
    newRequest: "Hacer una nueva solicitud",
    rgpdNotice: "🔒 Su información es estrictamente confidencial y se utiliza únicamente para evaluar su proyecto (conforme al RGPD).",
    invalidEmail: "Dirección de correo inválida",
    invalidPhone: "Número de teléfono inválido",
    submitting: "Enviando...",
    
    // Paso 1: Información Personal
    personalInfo: "Información Personal",
    personalInfoDesc: "Sus datos de contacto e información",
    recommended: "¿Ha sido recomendado por alguien?",
    selectAnswer: "Seleccione una respuesta",
    yes: "Sí",
    no: "No",
    recommendedByFull: "Por favor indique su nombre completo",
    civility: "Título",
    selectCivility: "Seleccione su título",
    mr: "Sr.",
    mrs: "Sra.",
    couple: "Pareja",
    lastName: "Apellido",
    lastNamePlaceholder: "Su apellido",
    firstName: "Nombre",
    firstNamePlaceholder: "Su nombre",
    address: "Dirección",
    addressPlaceholder: "Número y nombre de la calle",
    postalCode: "Código postal",
    postalCodePlaceholder: "Ej: 69001",
    city: "Ciudad",
    cityPlaceholder: "Su ciudad",
    phone: "Teléfono",
    phonePlaceholder: "06 12 34 56 78",
    email: "Email",
    emailPlaceholder: "su.email@ejemplo.com",
    birthDateMr: "Fecha de nacimiento - Sr.",
    birthDateMrs: "Fecha de nacimiento - Sra.",
    birthDatePlaceholder: "dd/mm/aaaa",
    
    // Paso 2: Situación Familiar
    familyStatus: "Situación Familiar",
    familyStatusDesc: "Información sobre su hogar",
    maritalStatus: "Estado civil",
    selectMaritalStatus: "Seleccione su estado",
    single: "Soltero(a)",
    married: "Casado(a)",
    pacs: "Pareja de hecho",
    divorced: "Divorciado(a)",
    children: "Número de hijos",
    childrenLabel: "Número de hijos",
    selectChildren: "Seleccione el número",
    currentRent: "Alquiler actual (€/mes)",
    currentRentLabel: "€ Alquiler mensual actual (€)",
    currentRentPlaceholder: "Ej: 800",
    
    // Paso 3: Ingresos Hombre
    maleIncome: "Ingresos Hombre",
    maleIncomeLabel: "Ingresos del Sr.",
    maleIncomeDesc: "Información profesional e ingresos",
    grossSalary: "Salario bruto (€/mes)",
    grossSalaryPlaceholder: "Ej: 3000",
    netSalary: "Salario neto (€/mes)",
    netSalaryPlaceholder: "Ej: 2400",
    bonuses: "Bonificaciones anuales (€)",
    bonusesPlaceholder: "Ej: 1200",
    status: "Estado",
    selectStatus: "Seleccione su estado",
    cdi: "Contrato indefinido",
    cdd: "Contrato temporal",
    interim: "Temporal",
    selfEmployed: "Autónomo",
    retired: "Jubilado",
    other: "Otro",
    profession: "Profesión",
    professionPlaceholder: "Su profesión",
    workplace: "Lugar de trabajo",
    workplacePlaceholder: "Ej: Lyon",
    
    // Paso 4: Ingresos Mujer
    femaleIncome: "Ingresos Mujer",
    femaleIncomeLabel: "Ingresos de la Sra.",
    femaleIncomeDesc: "Información profesional e ingresos",
    
    // Paso 5: Otros Ingresos
    otherIncome: "Otros Ingresos",
    otherIncomeDesc: "Ingresos adicionales",
    cafIncome: "Prestaciones familiares (€/mes)",
    cafIncomeLabel: "Prestaciones familiares (€)",
    cafIncomePlaceholder: "Ej: 200",
    
    // Paso 6: Situación Bancaria
    bankingSituation: "Situación Bancaria",
    bankingSituationDesc: "Sus créditos y compromisos bancarios",
    currentBank: "Banco actual",
    currentBankPlaceholder: "Ej: BNP Paribas",
    existingCredit: "Crédito en curso",
    existingCreditQuestion: "¿Tiene créditos en curso que terminan en más de 6 meses?",
    creditInfo: "Información sobre su crédito en curso",
    creditOrganization: "Organismo de crédito",
    creditOrganizationQuestion: "¿En qué organismo?",
    creditOrganizationPlaceholder: "Ej: Cetelem",
    monthlyPayment: "Mensualidad (€/mes)",
    monthlyPaymentQuestion: "¿Cuánto paga al mes (€)?",
    monthlyPaymentPlaceholder: "Ej: 300",
    remainingAmount: "Importe restante (€)",
    remainingAmountQuestion: "¿Cuánto le queda por pagar (€)?",
    remainingAmountPlaceholder: "Ej: 15000",
    financialSituation: "Situación Financiera",
    financialSituationDesc: "Su información bancaria y financiera",
    yourBanks: "¿Cuál(es) es/son su(s) banco(s) actual(es)",
    yourBanksPlaceholder: "Ej: Crédit Agricole, BNP Paribas...",
    downPayment: "¿Cuál es su aporte disponible para su proyecto (€)",
    downPaymentPlaceholder: "0",
    desiredMonthlyRepayment: "Mensualidad de reembolso de préstamo deseada (€)",
    desiredMonthlyRepaymentPlaceholder: "0",
    
    // Paso 7: Proyecto Inmobiliario
    realEstateProject: "Proyecto Inmobiliario",
    realEstateProjectDesc: "La propiedad que busca",
    yourRealEstateProject: "Su Proyecto Inmobiliario",
    describePropertyYouAreLookingFor: "Describa el inmueble que busca",
    propertyType: "Tipo de propiedad",
    propertyTypeLabel: "Tipo de inmueble buscado",
    selectPropertyType: "Seleccione el tipo",
    selectPropertyTypePlaceholder: "Elija el tipo de inmueble",
    apartment: "Apartamento",
    house: "Casa",
    bedrooms: "Número de habitaciones",
    bedroomsLabel: "Número de habitaciones deseadas",
    bedroomsPlaceholder: "Número de habitaciones",
    selectBedrooms: "Seleccione el número",
    citiesOrDepartments: "¿En qué ciudades o departamentos le gustaría vivir?",
    citiesPlaceholder: "Ej: Lyon, Villeurbanne, Rhône (69), etc.",
    contribution: "Aportación personal (€)",
    contributionPlaceholder: "Ej: 50000",
    desiredMonthly: "Mensualidad deseada (€/mes)",
    desiredMonthlyPlaceholder: "Ej: 1200",
    propertyDescription: "Criterios importantes para usted",
    propertyDescriptionPlaceholder: "Describa sus expectativas (proximidad a transportes, escuelas, comercios, etc.)",
  },
  
  it: {
    // Intestazione
    headerTitle: "Modulo di richiesta di informazioni strettamente confidenziale per valutare la sua capacità di indebitamento e proporle immobili nuovi che corrispondano alle sue aspettative",
    stepProgress: "Passo",
    of: "di",
    
    // Navigazione
    previous: "Precedente",
    next: "Successivo",
    submit: "Invia modulo",
    fillRequired: "Si prega di compilare i campi obbligatori evidenziati in rosso",
    fieldsRemaining: "campo/i obbligatorio/i da compilare",
    allFieldsCompleted: "Tutti i campi obbligatori sono compilati ✓",
    reviewTitle: "Verifica le tue informazioni",
    reviewDesc: "Controlla le tue risposte prima dell'invio definitivo.",
    edit: "Modifica",
    confirmSend: "Conferma e invia",
    draftRestored: "Le tue risposte precedenti sono state ripristinate",
    sending: "Invio in corso…",
    draftBannerText: "Hai un questionario in corso.",
    resume: "Riprendi",
    startOver: "Ricomincia",
    quickMinutes: "⏱️ Meno di 2 minuti",
    yourAdvisor: "Il tuo consulente:",
    recommendedBy: "Consigliato da",
    almostDone: "🎉 Ultimo passaggio, quasi finito!",
    pdfButton: "Scarica il mio riepilogo PDF",
    pdfGenerating: "Generazione del PDF…",
    pdfTitle: "Riepilogo della tua richiesta di stima",
    pdfIntro: "Ecco il riepilogo delle informazioni che ci hai fornito. Conserva questo documento; il nostro team ti contatterà molto presto.",
    pdfField: "Informazione",
    pdfValue: "Dettaglio",
    pdfFooter: "Documento generato automaticamente — LOVELIA — IMMOBILIER NEUF",
    pdfError: "Impossibile generare il PDF, riprova.",
    newRequest: "Fai una nuova richiesta",
    rgpdNotice: "🔒 Le tue informazioni sono strettamente riservate e utilizzate solo per valutare il tuo progetto (conforme al GDPR).",
    invalidEmail: "Indirizzo email non valido",
    invalidPhone: "Numero di telefono non valido",
    submitting: "Invio in corso...",
    
    // Passo 1: Informazioni Personali
    personalInfo: "Informazioni Personali",
    personalInfoDesc: "I suoi dati di contatto e informazioni",
    recommended: "È stato raccomandato da qualcuno?",
    selectAnswer: "Seleziona una risposta",
    yes: "Sì",
    no: "No",
    recommendedByFull: "Per favore indichi il nome completo",
    civility: "Titolo",
    selectCivility: "Seleziona il suo titolo",
    mr: "Sig.",
    mrs: "Sig.ra",
    couple: "Coppia",
    lastName: "Cognome",
    lastNamePlaceholder: "Il suo cognome",
    firstName: "Nome",
    firstNamePlaceholder: "Il suo nome",
    address: "Indirizzo",
    addressPlaceholder: "Numero e nome della via",
    postalCode: "Codice postale",
    postalCodePlaceholder: "Es: 69001",
    city: "Città",
    cityPlaceholder: "La sua città",
    phone: "Telefono",
    phonePlaceholder: "06 12 34 56 78",
    email: "Email",
    emailPlaceholder: "il.suo.email@esempio.com",
    birthDateMr: "Data di nascita - Sig.",
    birthDateMrs: "Data di nascita - Sig.ra",
    birthDatePlaceholder: "gg/mm/aaaa",
    
    // Passo 2: Situazione Familiare
    familyStatus: "Situazione Familiare",
    familyStatusDesc: "Informazioni sul suo nucleo familiare",
    maritalStatus: "Stato civile",
    selectMaritalStatus: "Selezioni il suo stato",
    single: "Celibe/Nubile",
    married: "Sposato(a)",
    pacs: "Unione civile",
    divorced: "Divorziato(a)",
    children: "Numero di figli",
    selectChildren: "Selezioni il numero",
    currentRent: "Affitto attuale (€/mese)",
    currentRentPlaceholder: "Es: 800",
    
    // Passo 3: Reddito Uomo
    maleIncome: "Reddito Uomo",
    maleIncomeDesc: "Informazioni professionali e reddito",
    grossSalary: "Stipendio lordo (€/mese)",
    grossSalaryPlaceholder: "Es: 3000",
    netSalary: "Stipendio netto (€/mese)",
    netSalaryPlaceholder: "Es: 2400",
    bonuses: "Bonus annuali (€)",
    bonusesPlaceholder: "Es: 1200",
    status: "Stato",
    selectStatus: "Selezioni il suo stato",
    cdi: "Contratto a tempo indeterminato",
    cdd: "Contratto a tempo determinato",
    interim: "Temporaneo",
    selfEmployed: "Lavoratore autonomo",
    retired: "Pensionato",
    other: "Altro",
    profession: "Professione",
    professionPlaceholder: "La sua professione",
    workplace: "Luogo di lavoro",
    workplacePlaceholder: "Es: Lyon",
    
    // Passo 4: Reddito Donna
    femaleIncome: "Reddito Donna",
    femaleIncomeLabel: "Redditi della Sig.ra",
    femaleIncomeDesc: "Informazioni professionali e reddito",
    
    // Passo 5: Altri Redditi
    otherIncome: "Altri Redditi",
    otherIncomeDesc: "Redditi aggiuntivi",
    cafIncome: "Prestazioni familiari (€/mese)",
    cafIncomeLabel: "Prestazioni familiari (€)",
    cafIncomePlaceholder: "Es: 200",
    
    // Passo 6: Situazione Bancaria
    bankingSituation: "Situazione Bancaria",
    bankingSituationDesc: "I suoi crediti e impegni bancari",
    currentBank: "Banca attuale",
    currentBankPlaceholder: "Es: BNP Paribas",
    existingCredit: "Credito in corso",
    existingCreditQuestion: "Ha crediti in corso che terminano tra più di 6 mesi?",
    creditInfo: "Informazioni sul suo credito in corso",
    creditOrganization: "Organismo di credito",
    creditOrganizationQuestion: "In quale organismo?",
    creditOrganizationPlaceholder: "Es: Cetelem",
    monthlyPayment: "Mensualità (€/mese)",
    monthlyPaymentQuestion: "Quanto paga al mese (€)?",
    monthlyPaymentPlaceholder: "Es: 300",
    remainingAmount: "Importo residuo (€)",
    remainingAmountQuestion: "Quanto le resta da pagare (€)?",
    remainingAmountPlaceholder: "Es: 15000",
    financialSituation: "Situazione Finanziaria",
    financialSituationDesc: "Le sue informazioni bancarie e finanziarie",
    yourBanks: "Qual è/sono la/le sua/sue banca/banche attuale/i",
    yourBanksPlaceholder: "Es: Crédit Agricole, BNP Paribas...",
    downPayment: "Qual è il suo apporto disponibile per il suo progetto (€)",
    downPaymentPlaceholder: "0",
    desiredMonthlyRepayment: "Rata mensile di rimborso prestito desiderata (€)",
    desiredMonthlyRepaymentPlaceholder: "0",
    remainingAmountQuestion: "¿Cuánto le queda por pagar (€)?",
    remainingAmountPlaceholder: "Es: 15000",
    financialSituation: "Situazione Finanziaria",
    financialSituationDesc: "Le sue informazioni bancarie e finanziarie",
    yourBanks: "Qual è/sono la/le sua/sue banca/banche attuale/i",
    yourBanksPlaceholder: "Es: Crédit Agricole, BNP Paribas...",
    downPayment: "Qual è il suo apporto disponibile per il suo progetto (€)",
    downPaymentPlaceholder: "0",
    desiredMonthlyRepayment: "Rata mensile di rimborso prestito desiderata (€)",
    desiredMonthlyRepaymentPlaceholder: "0",
    
    // Passo 7: Progetto Immobiliare
    realEstateProject: "Progetto Immobiliare",
    realEstateProjectDesc: "La proprietà che cerca",
    yourRealEstateProject: "Il Suo Progetto Immobiliare",
    describePropertyYouAreLookingFor: "Descriva l'immobile che sta cercando",
    propertyType: "Tipo di proprietà",
    propertyTypeLabel: "Tipo di immobile cercato",
    selectPropertyType: "Selezioni il tipo",
    selectPropertyTypePlaceholder: "Scelga il tipo di immobile",
    apartment: "Appartamento",
    house: "Casa",
    bedrooms: "Numero di camere",
    bedroomsLabel: "Numero di camere desiderato",
    bedroomsPlaceholder: "Numero di camere",
    selectBedrooms: "Selezioni il numero",
    citiesOrDepartments: "In quali città o dipartimenti vorrebbe vivere?",
    citiesPlaceholder: "Es: Lyon, Villeurbanne, Rhône (69), ecc.",
    contribution: "Contributo personale (€)",
    contributionPlaceholder: "Es: 50000",
    desiredMonthly: "Mensualità desiderata (€/mese)",
    desiredMonthlyPlaceholder: "Es: 1200",
    propertyDescription: "Criteri importanti per lei",
    propertyDescriptionPlaceholder: "Descriva le sue aspettative (vicinanza a trasporti, scuole, negozi, ecc.)",
  },
  
  ro: {
    // Antet
    headerTitle: "Formular de solicitare de informații strict confidențial pentru a evalua capacitatea dumneavoastră de îndatorare și pentru a vă propune proprietăți noi care corespund așteptărilor dumneavoastră",
    stepProgress: "Pasul",
    of: "din",
    
    // Navigare
    previous: "Anterior",
    next: "Următorul",
    submit: "Trimite formularul",
    fillRequired: "Vă rugăm să completați câmpurile obligatorii evidențiate cu roșu",
    fieldsRemaining: "câmp(uri) obligatoriu(ii) de completat",
    allFieldsCompleted: "Toate câmpurile obligatorii sunt completate ✓",
    reviewTitle: "Verificați informațiile",
    reviewDesc: "Verificați răspunsurile înainte de trimiterea finală.",
    edit: "Modifică",
    confirmSend: "Confirmă și trimite",
    draftRestored: "Răspunsurile dvs. anterioare au fost restaurate",
    sending: "Se trimite…",
    draftBannerText: "Aveți un chestionar în curs.",
    resume: "Reluați",
    startOver: "Începeți din nou",
    quickMinutes: "⏱️ Mai puțin de 2 minute",
    yourAdvisor: "Consilierul dvs.:",
    recommendedBy: "Recomandat de",
    almostDone: "🎉 Ultimul pas, aproape gata!",
    pdfButton: "Descarcă rezumatul meu PDF",
    pdfGenerating: "Se generează PDF-ul…",
    pdfTitle: "Rezumatul cererii dvs. de estimare",
    pdfIntro: "Iată rezumatul informațiilor pe care ni le-ați furnizat. Păstrați acest document; echipa noastră vă va contacta în curând.",
    pdfField: "Informație",
    pdfValue: "Detaliu",
    pdfFooter: "Document generat automat — LOVELIA — IMMOBILIER NEUF",
    pdfError: "Nu s-a putut genera PDF-ul, încercați din nou.",
    newRequest: "Faceți o nouă cerere",
    rgpdNotice: "🔒 Informațiile dvs. sunt strict confidențiale și utilizate doar pentru a evalua proiectul dvs. (conform GDPR).",
    invalidEmail: "Adresă de email invalidă",
    invalidPhone: "Număr de telefon invalid",
    submitting: "Se trimite...",
    
    // Pasul 1: Informații Personale
    personalInfo: "Informații Personale",
    personalInfoDesc: "Datele dumneavoastră de contact și informații",
    recommended: "Ați fost recomandat de cineva?",
    selectAnswer: "Selectați un răspuns",
    yes: "Da",
    no: "Nu",
    recommendedByFull: "Vă rugăm să indicați numele complet",
    civility: "Titlu",
    selectCivility: "Selectați titlul dumneavoastră",
    mr: "Dl.",
    mrs: "Dna.",
    couple: "Cuplu",
    lastName: "Nume",
    lastNamePlaceholder: "Numele dumneavoastră",
    firstName: "Prenume",
    firstNamePlaceholder: "Prenumele dumneavoastră",
    address: "Adresă",
    addressPlaceholder: "Număr și nume stradă",
    postalCode: "Cod poștal",
    postalCodePlaceholder: "Ex: 69001",
    city: "Oraș",
    cityPlaceholder: "Orașul dumneavoastră",
    phone: "Telefon",
    phonePlaceholder: "06 12 34 56 78",
    email: "Email",
    emailPlaceholder: "email.dumneavoastra@exemplu.com",
    birthDateMr: "Data nașterii - Dl.",
    birthDateMrs: "Data nașterii - Dna.",
    birthDatePlaceholder: "zz/ll/aaaa",
    
    // Pasul 2: Situația Familială
    familyStatus: "Situația Familială",
    familyStatusDesc: "Informații despre gospodăria dumneavoastră",
    familySituationAndIncome: "Situația Familială și Venituri",
    familySituationAndIncomeDesc: "Informații despre gospodăria și veniturile dumneavoastră",
    netMonthlyIncome: "Venituri lunare nete",
    maritalStatus: "Stare civilă",
    selectMaritalStatus: "Selectați starea dumneavoastră",
    single: "Celibatar(ă)",
    married: "Căsătorit(ă)",
    pacs: "Parteneriat civil",
    divorced: "Divorțat(ă)",
    children: "Număr de copii",
    childrenLabel: "Număr de copii",
    selectChildren: "Selectați numărul",
    currentRent: "Chirie actuală (€/lună)",
    currentRentLabel: "€ Chirie lunară actuală (€)",
    currentRentPlaceholder: "Ex: 800",
    
    // Pasul 3: Venituri Bărbat
    maleIncome: "Venituri Bărbat",
    maleIncomeLabel: "Veniturile Dl.",
    maleIncomeDesc: "Informații profesionale și venituri",
    grossSalary: "Salariu brut (€/lună)",
    grossSalaryPlaceholder: "Ex: 3000",
    netSalary: "Salariu net (€/lună)",
    netSalaryPlaceholder: "Ex: 2400",
    bonuses: "Bonusuri anuale (€)",
    bonusesPlaceholder: "Ex: 1200",
    status: "Statut",
    selectStatus: "Selectați statutul dumneavoastră",
    cdi: "Contract permanent",
    cdd: "Contract temporar",
    interim: "Temporar",
    selfEmployed: "Independent",
    retired: "Pensionar",
    other: "Altul",
    profession: "Profesie",
    professionPlaceholder: "Profesia dumneavoastră",
    workplace: "Loc de muncă",
    workplacePlaceholder: "Ex: Lyon",
    
    // Pasul 4: Venituri Femeie
    femaleIncome: "Venituri Femeie",
    femaleIncomeLabel: "Veniturile Dnei.",
    femaleIncomeDesc: "Informații profesionale și venituri",
    
    // Pasul 5: Alte Venituri
    otherIncome: "Alte Venituri",
    otherIncomeDesc: "Venituri suplimentare",
    cafIncome: "Alocații familiale (€/lună)",
    cafIncomeLabel: "Alocații familiale (€)",
    cafIncomePlaceholder: "Ex: 200",
    
    // Pasul 6: Situația Bancară
    bankingSituation: "Situația Bancară",
    bankingSituationDesc: "Creditele și angajamentele dumneavoastră bancare",
    currentBank: "Banca actuală",
    currentBankPlaceholder: "Ex: BNP Paribas",
    existingCredit: "Credit în curs",
    existingCreditQuestion: "Aveți credite în curs care se termină peste mai mult de 6 luni?",
    creditInfo: "Informații despre creditul dvs. în curs",
    creditOrganization: "Organism de credit",
    creditOrganizationQuestion: "În ce organism?",
    creditOrganizationPlaceholder: "Ex: Cetelem",
    monthlyPayment: "Plată lunară (€/lună)",
    monthlyPaymentQuestion: "Cât plătiți pe lună (€)?",
    monthlyPaymentPlaceholder: "Ex: 300",
    remainingAmount: "Suma rămasă (€)",
    remainingAmountQuestion: "Cât vă mai rămâne de plătit (€)?",
    remainingAmountPlaceholder: "Ex: 15000",
    financialSituation: "Situația Financiară",
    financialSituationDesc: "Informațiile dumneavoastră bancare și financiare",
    yourBanks: "Care este/sunt banca/băncile dumneavoastră actuală/actuale",
    yourBanksPlaceholder: "Ex: Crédit Agricole, BNP Paribas...",
    downPayment: "Care este aportul dumneavoastră disponibil pentru proiect (€)",
    downPaymentPlaceholder: "0",
    desiredMonthlyRepayment: "Rata lunară de rambursare a împrumutului dorită (€)",
    desiredMonthlyRepaymentPlaceholder: "0",
    
    // Pasul 7: Proiect Imobiliar
    realEstateProject: "Proiect Imobiliar",
    realEstateProjectDesc: "Proprietatea pe care o căutați",
    yourRealEstateProject: "Proiectul Dumneavoastră Imobiliar",
    describePropertyYouAreLookingFor: "Descrieți proprietatea pe care o căutați",
    propertyTypeLabel: "Tipul de proprietate căutat",
    selectPropertyTypePlaceholder: "Alegeți tipul de proprietate",
    bedroomsLabel: "Numărul dorit de dormitoare",
    bedroomsPlaceholder: "Număr de dormitoare",
    propertyType: "Tip de proprietate",
    selectPropertyType: "Selectați tipul",
    apartment: "Apartament",
    house: "Casă",
    bedrooms: "Număr de dormitoare",
    selectBedrooms: "Selectați numărul",
    citiesOrDepartments: "În ce orașe sau departamente ați dori să locuiți?",
    citiesPlaceholder: "Ex: Lyon, Villeurbanne, Rhône (69), etc.",
    contribution: "Contribuție personală (€)",
    contributionPlaceholder: "Ex: 50000",
    desiredMonthly: "Plată lunară dorită (€/lună)",
    desiredMonthlyPlaceholder: "Ex: 1200",
    propertyDescription: "Criterii importante pentru dumneavoastră",
    propertyDescriptionPlaceholder: "Descrieți așteptările dumneavoastră (proximitate transport, școli, magazine, etc.)",
  },
  
  de: {
    // Kopfzeile
    headerTitle: "Streng vertrauliches Informationsanfrageformular zur Bewertung Ihrer Kreditfähigkeit und zur Vorlage neuer Immobilien, die Ihren Erwartungen entsprechen",
    stepProgress: "Schritt",
    of: "von",
    
    // Navigation
    previous: "Zurück",
    next: "Weiter",
    submit: "Formular absenden",
    fillRequired: "Bitte füllen Sie die rot markierten Pflichtfelder aus",
    fieldsRemaining: "Pflichtfeld(er) auszufüllen",
    allFieldsCompleted: "Alle Pflichtfelder ausgefüllt ✓",
    reviewTitle: "Überprüfen Sie Ihre Angaben",
    reviewDesc: "Bitte überprüfen Sie Ihre Antworten vor dem endgültigen Absenden.",
    edit: "Bearbeiten",
    confirmSend: "Bestätigen und senden",
    draftRestored: "Ihre vorherigen Antworten wurden wiederhergestellt",
    sending: "Wird gesendet…",
    draftBannerText: "Sie haben einen laufenden Fragebogen.",
    resume: "Fortsetzen",
    startOver: "Neu beginnen",
    quickMinutes: "⏱️ Weniger als 2 Minuten",
    yourAdvisor: "Ihr Berater:",
    recommendedBy: "Empfohlen von",
    almostDone: "🎉 Letzter Schritt, fast fertig!",
    pdfButton: "Meine PDF-Zusammenfassung herunterladen",
    pdfGenerating: "PDF wird erstellt…",
    pdfTitle: "Zusammenfassung Ihrer Schätzungsanfrage",
    pdfIntro: "Hier ist die Zusammenfassung der von Ihnen übermittelten Informationen. Bewahren Sie dieses Dokument auf; unser Team wird Sie sehr bald kontaktieren.",
    pdfField: "Information",
    pdfValue: "Detail",
    pdfFooter: "Automatisch erstelltes Dokument — LOVELIA — IMMOBILIER NEUF",
    pdfError: "PDF konnte nicht erstellt werden, bitte erneut versuchen.",
    newRequest: "Neue Anfrage stellen",
    rgpdNotice: "🔒 Ihre Angaben sind streng vertraulich und werden nur zur Bewertung Ihres Projekts verwendet (DSGVO-konform).",
    invalidEmail: "Ungültige E-Mail-Adresse",
    invalidPhone: "Ungültige Telefonnummer",
    submitting: "Wird gesendet...",
    
    // Schritt 1: Persönliche Informationen
    personalInfo: "Persönliche Informationen",
    personalInfoDesc: "Ihre Kontaktdaten und Informationen",
    recommended: "Wurden Sie von jemandem empfohlen?",
    selectAnswer: "Wählen Sie eine Antwort",
    yes: "Ja",
    no: "Nein",
    recommendedByFull: "Bitte geben Sie den vollständigen Namen an",
    civility: "Anrede",
    selectCivility: "Wählen Sie Ihre Anrede",
    mr: "Herr",
    mrs: "Frau",
    couple: "Paar",
    lastName: "Nachname",
    lastNamePlaceholder: "Ihr Nachname",
    firstName: "Vorname",
    firstNamePlaceholder: "Ihr Vorname",
    address: "Adresse",
    addressPlaceholder: "Hausnummer und Straßenname",
    postalCode: "Postleitzahl",
    postalCodePlaceholder: "Z.B.: 69001",
    city: "Stadt",
    cityPlaceholder: "Ihre Stadt",
    phone: "Telefon",
    phonePlaceholder: "06 12 34 56 78",
    email: "E-Mail",
    emailPlaceholder: "ihre.email@beispiel.de",
    birthDateMr: "Geburtsdatum - Herr",
    birthDateMrs: "Geburtsdatum - Frau",
    birthDatePlaceholder: "tt/mm/jjjj",
    
    // Schritt 2: Familiensituation
    familyStatus: "Familiensituation",
    familyStatusDesc: "Informationen über Ihren Haushalt",
    maritalStatus: "Familienstand",
    selectMaritalStatus: "Wählen Sie Ihren Status",
    single: "Ledig",
    married: "Verheiratet",
    pacs: "Eingetragene Partnerschaft",
    divorced: "Geschieden",
    children: "Anzahl der Kinder",
    selectChildren: "Wählen Sie die Anzahl",
    currentRent: "Aktuelle Miete (€/Monat)",
    currentRentPlaceholder: "Z.B.: 800",
    
    // Schritt 3: Einkommen Mann
    maleIncome: "Einkommen Mann",
    maleIncomeDesc: "Berufliche Informationen und Einkommen",
    grossSalary: "Bruttogehalt (€/Monat)",
    grossSalaryPlaceholder: "Z.B.: 3000",
    netSalary: "Nettogehalt (€/Monat)",
    netSalaryPlaceholder: "Z.B.: 2400",
    bonuses: "Jahresboni (€)",
    bonusesPlaceholder: "Z.B.: 1200",
    status: "Status",
    selectStatus: "Wählen Sie Ihren Status",
    cdi: "Unbefristeter Vertrag",
    cdd: "Befristeter Vertrag",
    interim: "Zeitarbeit",
    selfEmployed: "Selbstständig",
    retired: "Rentner",
    other: "Sonstiges",
    profession: "Beruf",
    professionPlaceholder: "Ihr Beruf",
    workplace: "Arbeitsplatz",
    workplacePlaceholder: "Z.B.: Lyon",
    
    // Schritt 4: Einkommen Frau
    femaleIncome: "Einkommen Frau",
    femaleIncomeLabel: "Einkommen der Frau",
    femaleIncomeDesc: "Berufliche Informationen und Einkommen",
    
    // Schritt 5: Sonstige Einkommen
    otherIncome: "Sonstige Einkommen",
    otherIncomeDesc: "Zusätzliche Einkommen",
    cafIncome: "Familienzulagen (€/Monat)",
    cafIncomeLabel: "Familienzulagen (€)",
    cafIncomePlaceholder: "Z.B.: 200",
    
    // Schritt 6: Banksituation
    bankingSituation: "Banksituation",
    bankingSituationDesc: "Ihre Kredite und banklichen Verpflichtungen",
    currentBank: "Aktuelle Bank",
    currentBankPlaceholder: "Z.B.: BNP Paribas",
    existingCredit: "Laufender Kredit",
    existingCreditQuestion: "Haben Sie laufende Kredite, die in mehr als 6 Monaten enden?",
    creditInfo: "Informationen zu Ihrem laufenden Kredit",
    creditOrganization: "Kreditinstitut",
    creditOrganizationQuestion: "Bei welchem Institut?",
    creditOrganizationPlaceholder: "Z.B.: Cetelem",
    monthlyPayment: "Monatliche Rate (€/Monat)",
    monthlyPaymentQuestion: "Wie viel zahlen Sie pro Monat (€)?",
    monthlyPaymentPlaceholder: "Z.B.: 300",
    remainingAmount: "Restbetrag (€)",
    remainingAmountQuestion: "Wie viel müssen Sie noch zurückzahlen (€)?",
    remainingAmountPlaceholder: "Z.B.: 15000",
    financialSituation: "Finanzielle Situation",
    financialSituationDesc: "Ihre Bank- und Finanzinformationen",
    yourBanks: "Was ist/sind Ihre aktuelle(n) Bank(en)",
    yourBanksPlaceholder: "Z.B.: Crédit Agricole, BNP Paribas...",
    downPayment: "Was ist Ihre verfügbare Anzahlung für Ihr Projekt (€)",
    downPaymentPlaceholder: "0",
    desiredMonthlyRepayment: "Gewünschte monatliche Kreditrückzahlung (€)",
    desiredMonthlyRepaymentPlaceholder: "0",
    
    // Schritt 7: Immobilienprojekt
    realEstateProject: "Immobilienprojekt",
    realEstateProjectDesc: "Die Immobilie, die Sie suchen",
    yourRealEstateProject: "Ihr Immobilienprojekt",
    describePropertyYouAreLookingFor: "Beschreiben Sie die Immobilie, die Sie suchen",
    propertyType: "Immobilientyp",
    propertyTypeLabel: "Gesuchter Immobilientyp",
    selectPropertyType: "Wählen Sie den Typ",
    selectPropertyTypePlaceholder: "Wählen Sie den Immobilientyp",
    apartment: "Wohnung",
    house: "Haus",
    bedrooms: "Anzahl der Schlafzimmer",
    bedroomsLabel: "Gewünschte Anzahl der Schlafzimmer",
    bedroomsPlaceholder: "Anzahl der Schlafzimmer",
    selectBedrooms: "Wählen Sie die Anzahl",
    citiesOrDepartments: "In welchen Städten oder Departements möchten Sie wohnen?",
    citiesPlaceholder: "Z.B.: Lyon, Villeurbanne, Rhône (69), usw.",
    contribution: "Eigenkapital (€)",
    contributionPlaceholder: "Z.B.: 50000",
    desiredMonthly: "Gewünschte monatliche Rate (€/Monat)",
    desiredMonthlyPlaceholder: "Z.B.: 1200",
    propertyDescription: "Wichtige Kriterien für Sie",
    propertyDescriptionPlaceholder: "Beschreiben Sie Ihre Erwartungen (Nähe zu Verkehrsmitteln, Schulen, Geschäften, usw.)",
  }
};

// Fonction helper pour obtenir les traductions
export const t = (key, lang = 'fr') => {
  return translations[lang]?.[key] || translations.fr[key] || key;
};
